const API_PATH = process.env.REACT_APP_API_PATH;
async function sendJobApplication(data) {
	let options = {
		method: "POST", // *GET, POST, PUT, DELETE, etc.
		// mode: "cors", // no-cors, *cors, same-origin
		// cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: "same-origin", // include, *same-origin, omit
		headers: {
			// "Content-Type": "application/json",
			// "Content-Type": "application/x-www-form-urlencoded",
			// "Content-Type": "multipart/form-data",
		},
	};
	const res = await fetch(`${API_PATH}/jobs/submit`, {
		...options,
		body: data,
	});
	return await res.json();
}
async function uploadEvent(data) {
	let options = {
		method: "POST", // *GET, POST, PUT, DELETE, etc.
		// mode: "cors", // no-cors, *cors, same-origin
		// cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: "same-origin", // include, *same-origin, omit
		headers: {
			// "Content-Type": "application/json",
			// "Content-Type": "application/x-www-form-urlencoded",
			// "Content-Type": "multipart/form-data",
		},
	};
	const res = await fetch(`${API_PATH}/news/submit`, {
		...options,
		body: data,
	});
	return await res.json();
}
async function sendCOVIDQuestion(data) {
	let options = {
		method: "POST", // *GET, POST, PUT, DELETE, etc.
		// mode: "cors", // no-cors, *cors, same-origin
		// cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: "same-origin", // include, *same-origin, omit
		headers: {
			"Content-Type": "application/json",
			// "Content-Type": "application/x-www-form-urlencoded",
			// "Content-Type": "multipart/form-data",
		},
	};
	const res = await fetch(`${API_PATH}/covid/submit`, {
		...options,
		body: JSON.stringify(data),
	});
	return await res.json();
}
async function sendCOVIDAnswer(data) {
	let options = {
		method: "POST", // *GET, POST, PUT, DELETE, etc.
		// mode: "cors", // no-cors, *cors, same-origin
		// cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: "same-origin", // include, *same-origin, omit
		headers: {
			"Content-Type": "application/json",
			// "Content-Type": "application/x-www-form-urlencoded",
			// "Content-Type": "multipart/form-data",
		},
	};
	const res = await fetch(`${API_PATH}/covid/answer`, {
		...options,
		body: JSON.stringify(data),
	});
	return await res.json();
}
async function getCOVIDQuestions() {
	let options = {
		method: "GET", // *GET, POST, PUT, DELETE, etc.
		// mode: "cors", // no-cors, *cors, same-origin
		// cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: "same-origin", // include, *same-origin, omit
		headers: {
			// "Content-Type": "application/json",
			// "Content-Type": "application/x-www-form-urlencoded",
			// "Content-Type": "multipart/form-data",
		},
	};
	const res = await fetch(`${API_PATH}/covid/questions`, {
		...options,
	});
	return await res.json();
}

export {
	sendJobApplication,
	uploadEvent,
	sendCOVIDQuestion,
	sendCOVIDAnswer,
	getCOVIDQuestions,
};
